import { render, staticRenderFns } from "./developer_services.vue?vue&type=template&id=5203ff66&scoped=true&"
import script from "./developer_services.vue?vue&type=script&lang=js&"
export * from "./developer_services.vue?vue&type=script&lang=js&"
import style0 from "./developer_services.vue?vue&type=style&index=0&id=5203ff66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203ff66",
  null
  
)

export default component.exports